var map = {
	"./1.jpg": 9652,
	"./10.jpg": 7174,
	"./11.jpg": 608,
	"./12.jpg": 6420,
	"./2.jpg": 3347,
	"./3.jpg": 8086,
	"./4.jpg": 8605,
	"./5.jpg": 9392,
	"./6.jpg": 6031,
	"./7.jpg": 9650,
	"./8.jpg": 6809,
	"./9.jpg": 5196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9966;